module.exports = __webpack_public_path__ + "img/rw.4c698271.png";